import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FlamingoHttpService } from '@flamingo/service/flamingo-http.service';
import { Observable, Subject } from 'rxjs';
import { ClientView } from '../../../../../../core/model/client-view.model';
import { Client } from '../../../../../../core/model/client.model';
import { PaginatedList } from '../../../../../../core/model/paginated-list.model';

@Injectable({
  providedIn: 'root',
})
export class ClientService {

  public refreshClient$ = new Subject();

  constructor(private _httpService: FlamingoHttpService) {
  }

  public list(page?: number, pageSize?: number, sort?: string, sortOrder?: string, filter?: string): Observable<PaginatedList<ClientView>> {
    const params = new HttpParams()
      .set('page', page ? `${page}` : '0')
      .set('pageSize', pageSize ? `${pageSize}` : '10')
      .set('sort', sort ? sort : 'id')
      .set('sortOrder', sortOrder ? sortOrder : 'ASC')
      .set('filter', filter ? filter : '');

    return this._httpService.get(`/client/all`, params);
  }

  public detail(debtorTaxCodePrefix: string, debtorTaxCode: string): Observable<ClientView> {
    const params = new HttpParams()
      .set('debtorTaxCodePrefix', debtorTaxCodePrefix)
      .set('debtorTaxCode', debtorTaxCode);

    return this._httpService.get(`/client`, params);
  }

  public save(client: Client | ClientView): Observable<Client> {
    return this._httpService.post(`/client`, client);
  }

  public update(client: Client): Observable<Client> {
    return this._httpService.put(`/client/${client.id}`, client);
  }

  public delete(clientId: number): Observable<Client> {
    return this._httpService.delete(`/client/${clientId}`);
  }

}
